import { render, staticRenderFns } from "./GhostLoader.vue?vue&type=template&id=f793c01a&scoped=true&"
import script from "./GhostLoader.vue?vue&type=script&lang=js&"
export * from "./GhostLoader.vue?vue&type=script&lang=js&"
import style0 from "./GhostLoader.vue?vue&type=style&index=0&id=f793c01a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f793c01a",
  null
  
)

export default component.exports